import React, { FC } from 'react';
import Link from 'next/link';
import OnboardingPageLayout from '~/src/components/PageLayout/OnboardingPageLayout';
import {
  contentContainerStyles,
  pictureContainerStyles,
  imageStyles,
  linkStyles,
  pulseStyles,
  buttonStyles,
  contentBlockerStyles,
  buttonTextStyles,
  buttonIconStyles,
} from './styles.css';
import { OnboardingAppTypes, useOnboardingServices } from '~/src/components/CustomApp/OnboardingCustomApp';
import { TAP_EVENTS } from '~/src/services/analytics/contants';

const Guest: FC<OnboardingAppTypes> = () => {
  const { Analytics, isDesktop, isDeeplinkModalOpen } = useOnboardingServices();

  const handlePlay = () => {
    Analytics.sendEvent(TAP_EVENTS.mainMenuPlay);
  };

  return (
    <>
      <OnboardingPageLayout isDesktop={isDesktop}>
        <div className={contentContainerStyles}>
          <picture className={pictureContainerStyles}>
            <source srcSet="/assets/images/guest-board.avif" type="image/avif" />
            <source srcSet="/assets/images/guest-board.webp" type="image/webp" />
            <img
              alt="Chess board in initial position"
              src="/assets/images/guest-board.png"
              // @ts-expect-error
              fetchpriority="high"
              className={imageStyles}
            />
          </picture>

          <Link passHref href="/onboarding/game">
            <a className={linkStyles}>
              <button className={`${buttonStyles} ${!isDeeplinkModalOpen && pulseStyles}`} onClick={handlePlay}>
                <span className={buttonTextStyles}>
                  <svg
                    width="17"
                    height="22"
                    viewBox="0 0 17 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={buttonIconStyles}
                  >
                    <path d="M0.800781 0.599609L16.4008 11.0776L0.800781 21.3996V0.599609Z" fill="#3D303B" />
                  </svg>
                  Play
                </span>
              </button>
            </a>
          </Link>

          <div className={contentBlockerStyles} />
        </div>
      </OnboardingPageLayout>
    </>
  );
};

export default Guest;
